import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import TableComponent, { TableOp } from "../../../components/table/TableOps";
import { withRouter } from "react-router-dom";
import ContraRecibo from "../ContraRecibos/ContraRecibo";
import ACCESS from "../../../ACCESS";

class FacturasClientes extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `factura-cliente/filter`,
        deleteUrl: "factura-cliente/delete",
        deleteField: "id",
        modUrl: "/Cobranza/FacturaCliente",
      },
      TableOp.Table(
        false,
        [
          { label: "Folio", id: "folio" },
          { label: "Cliente", id: "cliente" },
          { label: "Recibido", id: "recibido" },
          { label: "Usuario", id: "usuario" },
          { label: "Fecha", id: "createdAt" },
        ],
        [
          { id: 'edit', icon: 'edit', access: [ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_FOLIOS_CREADOS_POR_USUARIO, ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_TODOS_LOS_FOLIOS] },
          { id: 'contrarecibo', icon: 'add', tooltip: 'Contrarecibo', access: [ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.MARCAR_RECIBIDO] }
        ]
      )
    );
    this.table();
  }

  action = (id, row) => {
    if (id === 'edit') {
      this.props.history.push(`${this.config.modUrl}/${row.id}`)
    } else if (id === 'delete') {
      this.delete(row)
    } else if (id === 'contrarecibo') {
      this.setState({ crDialog: { visible: true, row } });
    }
  }

  onContraReciboSave = () => {
    this.setState({ crDialog: { visible: false } });
    this.table();
  }

  onContraReciboClose = () => {
    this.setState({ crDialog: { visible: false } });
  }

  render() {
    const { crDialog = { visible: false } } = this.state;
    const { hasAccess } = this.context;

    return (
      <div>
        <div
          style={{
            padding: "0px 10px",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <h1>Folios Facturas por Cliente</h1>
          {
            hasAccess(ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.CREAR_FOLIO) &&
            <Button color="primary" variant={"contained"} onClick={() => { this.props.history.push(`/Cobranza/FacturaCliente/`) }} >
              Nuevo
            </Button>
          }
        </div>
        <this.TableRender />

        <Dialog
          onClose={this.onContraReciboClose}
          open={crDialog.visible}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle onClose={this.onContraReciboClose}>Factura</DialogTitle>
          <DialogContent dividers>
            <ContraRecibo
              clientesFacturas
              factura={crDialog.row}
              onSave={this.onContraReciboSave}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onContraReciboClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(FacturasClientes);
